export default "__VITE_ASSET__DvXKKUJu__"